import { SvgIcon } from '@mui/material'

const Bedroom = props => (
  <SvgIcon
    viewBox="0 0 16 16"
    {...props}
    sx={{
      fill: 'none'
    }}
  >
    <path
      d="M3.52876 1.52861C3.65378 1.40358 3.82335 1.33334 4.00016 1.33334H14.0002C14.3684 1.33334 14.6668 1.63182 14.6668 2.00001V14C14.6668 14.3682 14.3684 14.6667 14.0002 14.6667H8.66827C8.66779 14.6667 8.66731 14.6667 8.66683 14.6667L4.00016 14.6667L2.00016 14.6667C1.63197 14.6667 1.3335 14.3682 1.3335 14V8.72001C1.3335 8.48861 1.45349 8.27376 1.65051 8.15239L3.3335 7.11567V2.00001C3.3335 1.8232 3.40373 1.65363 3.52876 1.52861ZM4.66683 6.29434L4.98384 6.09906C5.19824 5.96699 5.46875 5.96699 5.68315 6.09906L9.01648 8.15239C9.2135 8.27376 9.3335 8.48861 9.3335 8.72001V13.3333H13.3335V2.66668H4.66683V6.29434ZM8.00016 13.3333V9.09234L5.3335 7.44968L2.66683 9.09234V13.3333H3.99872C3.9992 13.3333 3.99968 13.3333 4.00016 13.3333H4.66683V10.6667H6.00016V13.3333L8.00016 13.3333ZM7.3335 4.66668V6.00001H8.66683V4.66668H7.3335ZM12.0002 4.66668H10.6668V6.00001H12.0002V4.66668ZM10.6668 7.33334H12.0002V8.66668H10.6668V7.33334ZM12.0002 10H10.6668V11.3333H12.0002V10Z"
      fill="#050A22"
    />
  </SvgIcon>
)

export default Bedroom
